import React from 'react'
import { Trash2 } from 'lucide-react'
import { getRelativeTime } from '../utils/conversationUtils'

interface ConversationItemProps {
    id: string
    title: string
    timestamp: number
    isActive: boolean
    onClick: () => void
    onDelete: (e: React.MouseEvent) => void
}

export const ConversationItem: React.FC<ConversationItemProps> = ({
    title,
    timestamp,
    isActive,
    onClick,
    onDelete
}) => {
    return (
        <div
            onClick={onClick}
            className={`group flex items-center justify-between p-2 rounded-md cursor-pointer transition-colors ${isActive
                ? 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                }`}
        >
            <div className="flex-1 min-w-0 mr-3">
                <h4
                    className={`text-sm font-medium truncate ${isActive ? 'text-gray-900 dark:text-white' : 'text-gray-900 dark:text-gray-100'
                        }`}
                >
                    {title}
                </h4>
            </div>
            <div className="flex items-center gap-2 shrink-0">
                <span
                    className={`text-xs ${isActive
                        ? 'text-gray-500 dark:text-gray-400'
                        : 'text-gray-400'
                        }`}
                >
                    {getRelativeTime(timestamp)}
                </span>
                <button
                    onClick={onDelete}
                    className={`p-1 rounded opacity-0 group-hover:opacity-100 transition-all ${isActive
                        ? 'hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400 hover:text-red-500'
                        : 'hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-400 hover:text-red-500'
                        }`}
                    title="Deletar conversa"
                >
                    <Trash2 className="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
    )
}
